import { SVGProps } from "react";

export function Twitter(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 15 15"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_861_798)">
        <g mask="url(#mask0_861_798)">
          <path
            d="M11.525 1.15112H13.672L8.982 6.52512L14.5 13.8391H10.18L6.794 9.40412L2.924 13.8391H0.775L5.791 8.08912L0.5 1.15212H4.93L7.986 5.20512L11.525 1.15112ZM10.77 12.5511H11.96L4.28 2.37212H3.004L10.77 12.5511Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_861_798">
          <rect
            width="15"
            height="15"
            fill="curerntColor"
            transform="translate(0.5 0.495117)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
